import "./situation.scss";
import {
  Form,
  InputButtonGroup,
  useFormConfig,
} from "@lya-protect/lya-protect-form-library/dist/FormAPI";
import {
  Button,
  Emphasis,
  FormAction,
  FormBloc,
  FormField,
  FormGrid,
  FormRow,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import { NavButton } from "@src/components/navButton/NavButton";
import { InfoBloc } from "@src/components/infoBloc/InfoBloc";
import { zod } from "@lya-protect/lya-protect-form-library/dist/Exports";
import { useEffect } from "react";
import { StepProps } from "../../step/Steps";

export type SituationData =
  | {
      isMemberTutelaire: boolean;
      hasContractPavixie?: boolean;
    }
  | undefined;
type LandingProps = StepProps<SituationData>;

const schema = zod.object({
  isMemberTutelaire: zod.boolean({
    required_error: "Ce champ est obligatoire",
  }),
  hasContractPavixie: zod
    .boolean({
      required_error: "Ce champ est obligatoire",
    })
    .optional(),
});
type FormValues = zod.infer<typeof schema>;

export function Situation({ data, changeStep, setData }: LandingProps) {
  const formConfig = useFormConfig<typeof schema, FormValues>({
    schema,
    defaultValues: data,
  });

  const isMemberTutelaire = formConfig.watch("isMemberTutelaire");
  const hasContractPavixie = formConfig.watch("hasContractPavixie");

  useEffect(() => {
    if (isMemberTutelaire === false) {
      formConfig.setValue("hasContractPavixie", undefined);
    }
  }, [isMemberTutelaire, formConfig]);

  return (
    <div className="situation-step">
      <div className="stepper__centered-container">
        <div className="stepper__centered-content step__grid step__grid--padding-bottom ">
          <NavButton onClick={() => changeStep("LANDING", "backward")}>
            Précédent
          </NavButton>
          <h1>
            Mieux <Emphasis>vous connaître</Emphasis> :
          </h1>
          <Form
            className="situation-step__form"
            formConfig={formConfig}
            onSubmit={(submittedData) => {
              setData(submittedData);
              changeStep("BIRTHDATE", "forward");
            }}
          >
            <FormGrid size="large">
              <FormRow>
                <FormField>
                  <InputButtonGroup<FormValues, boolean>
                    label="Êtes-vous adhérent à la mutuelle Tutélaire ?"
                    size="large"
                    name="isMemberTutelaire"
                    required
                    options={[
                      { label: "Oui", value: true },
                      { label: "Non", value: false },
                    ]}
                  />
                </FormField>
              </FormRow>
              {isMemberTutelaire === true && (
                <>
                  <FormRow>
                    <FormField>
                      <InputButtonGroup<FormValues, boolean>
                        label="Êtes-vous détenteur d’un contrat Paxivie ?"
                        size="large"
                        name="hasContractPavixie"
                        required
                        options={[
                          { label: "Oui", value: true },
                          { label: "Non", value: false },
                        ]}
                      />
                    </FormField>
                  </FormRow>
                  {hasContractPavixie && (
                    <FormBloc>
                      <InfoBloc variant="accent">
                        <p>
                          Si vous êtes déjà adhérent Paxivie, ce service en
                          ligne n&apos;étant disponible que pour les nouvelles
                          souscriptions, merci de contacter directement nos
                          conseillers pour une demande d&apos;avenant.
                          <br />
                          <br />
                          Vous pouvez joindre nos conseillers par téléphone :
                          <br />
                          - du lundi au vendredi
                          <br />- de 9h00 à 12h30 et de 13h30 à 17h au : 0 969
                          398 399 (appel non surtaxé).
                        </p>
                      </InfoBloc>
                    </FormBloc>
                  )}
                </>
              )}
              {!hasContractPavixie && (
                <FormAction>
                  <Button
                    type="submit"
                    disabled={
                      isMemberTutelaire === undefined ||
                      (isMemberTutelaire === true &&
                        hasContractPavixie !== false)
                    }
                  >
                    Suivant
                  </Button>
                </FormAction>
              )}
            </FormGrid>
          </Form>
        </div>
      </div>
    </div>
  );
}
